import { render, staticRenderFns } from "./swiper-banner.vue?vue&type=template&id=67f374ec&scoped=true&"
import script from "./swiper-banner.vue?vue&type=script&lang=js&"
export * from "./swiper-banner.vue?vue&type=script&lang=js&"
import style0 from "./swiper-banner.vue?vue&type=style&index=0&id=67f374ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f374ec",
  null
  
)

export default component.exports